export const translationDir = 'src/assets/i18n/';
export const defaultLanguage = 'en';

export const languages = new Map<string, string>([
  ['af', 'Afrikaans'],
  ['ar', 'Arabic'],
  ['ast', 'Asturian'],
  ['az', 'Azerbaijani'],
  ['be', 'Belarusian'],
  ['bg', 'Bulgarian'],
  ['bn', 'Bengali'],
  ['br', 'Breton'],
  ['bs', 'Bosnian'],
  ['ca', 'Catalan'],
  ['cs', 'Czech'],
  ['cy', 'Welsh'],
  ['da', 'Danish'],
  ['de', 'Deutsch'],
  ['dsb', 'Lower Sorbian'],
  ['el', 'Greek'],
  ['en-au', 'Australian English'],
  ['en-gb', 'British English'],
  ['en', 'English'],
  ['eo', 'Esperanto'],
  ['es-ar', 'Argentinian Spanish'],
  ['es-co', 'Colombian Spanish'],
  ['es-mx', 'Mexican Spanish'],
  ['es-ni', 'Nicaraguan Spanish'],
  ['es-ve', 'Venezuelan Spanish'],
  ['es', 'Español'],
  ['et', 'Estonian'],
  ['eu', 'Basque'],
  ['fa', 'Persian'],
  ['fi', 'Finnish'],
  ['fr', 'Français'],
  ['fy', 'Frisian'],
  ['ga', 'Irish'],
  ['gd', 'Scottish Gaelic'],
  ['gl', 'Galician'],
  ['he', 'Hebrew'],
  ['hi', 'Hindi'],
  ['hr', 'Croatian'],
  ['hsb', 'Upper Sorbian'],
  ['hu', 'Hungarian'],
  ['ia', 'Interlingua'],
  ['id', 'Indonesian'],
  ['io', 'Ido'],
  ['is', 'Icelandic'],
  ['it', 'Italiano'],
  ['ja', 'Japanese'],
  ['ka', 'Georgian'],
  ['kk', 'Kazakh'],
  ['km', 'Khmer'],
  ['kn', 'Kannada'],
  ['ko', 'Korean'],
  ['lb', 'Luxembourgish'],
  ['lt', 'Lithuanian'],
  ['lv', 'Latvian'],
  ['mk', 'Macedonian'],
  ['ml', 'Malayalam'],
  ['mn', 'Mongolian'],
  ['mr', 'Marathi'],
  ['my', 'Burmese'],
  ['nb', 'Norwegian Bokmål'],
  ['ne', 'Nepali'],
  ['nl', 'Dutch'],
  ['nn', 'Norwegian Nynorsk'],
  ['os', 'Ossetic'],
  ['pa', 'Punjabi'],
  ['pl', 'Polish'],
  ['pt-br', 'Brazilian Portuguese'],
  ['pt', 'Portuguese'],
  ['ro', 'Romanian'],
  ['ru', 'Russian'],
  ['sk', 'Slovak'],
  ['sl', 'Slovenian'],
  ['sq', 'Albanian'],
  ['sr-latn', 'Serbian Latin'],
  ['sr', 'Serbian'],
  ['sv', 'Swedish'],
  ['sw', 'Swahili'],
  ['ta', 'Tamil'],
  ['te', 'Telugu'],
  ['th', 'Thai'],
  ['tr', 'Turkish'],
  ['tt', 'Tatar'],
  ['udm', 'Udmurt'],
  ['uk', 'Ukrainian'],
  ['vi', 'Vietnamese'],
  ['zh-hans', '中文'],
  ['zh-hant', 'Traditional Chinese'],
]);
